import React, { useState } from 'react';
import '../CSS/Tabs.css';
import '../CSS/Responsive.css'
import LazyLoad from 'react-lazy-load';

const Tab = ( {tabs} ) => {
    const {constIdea, tabsData} = tabs;
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (index) => {
      setActiveTab(index);
    };

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    
    const handleLoad = () => {
      setIsLoading(false); // Image has loaded successfully
    };
    
    const handleError = () => {
      setIsLoading(false); // Image failed to load
      setHasError(true);
    };
  
    return (
      <>
      {constIdea && <div className="mob_tabconstIdea" style={{margin: '12rem 0rem'}}>{constIdea()}</div>}
      <div className="tab-container">
        
        <div className={`tab-buttons ${constIdea ? 'portfolioTab' : 'mainTab'}`}>
          {/* <div className='btns-wrapper'> */}
            {tabsData.map((tab, index) => (
              <React.Fragment>
                <button
                key={index}
                className={activeTab === index ? 'active' : 'tab_btn'}
                onClick={() => handleTabChange(index)}
                >
                    {
                      tab.tabTitle
                    }
                </button>
                <span className={`${tabsData.length-1 == index ? 'last' : 'btn_border'}`}></span>
              </React.Fragment>
            ))}
          {/* </div> */}
        </div>

        {constIdea && <div className="tabconstIdea" style={{margin: '12rem 0rem'}}>{constIdea()}</div>}
        {
          constIdea && <div className="tab-content">
                {tabsData[activeTab].categories.map((category, index) => (
                  <LazyLoad className='lazyload'>
                    <React.Fragment>
                      {isLoading && !hasError && (
                        <div className="loading-fallback">Loading...</div>
                      )}
                      {hasError && (
                        <div className="error-fallback">Image failed to load.</div>
                      )}
                      <img 
                        className={'portfolio_images'} key={index} src={category} 
                        alt={tabsData[activeTab].tabTitle} 
                        onLoad={handleLoad} // Triggered when the image loads
                        onError={handleError} // Triggered if the image fails to load
                        style={{ display: isLoading || hasError ? 'none' : '' }}
                      />
                    </React.Fragment>
                  </LazyLoad>
                ))}
          </div>
        }
         
        {constIdea || 
          <div className="tab-content right">
              {tabsData[activeTab].categories.map((category, index) => (
                <span style={{fontSize: `${tabsData[activeTab].width}`, marginRight: '2rem', 
                borderLeft: '1px solid #FF4137', marginBottom: '1.9rem', paddingLeft: '1rem'}}
                >
                  {category}
                </span>
              ))}
        </div>
        }
      </div>
    </>
    );
};

export default Tab;